import React from 'react';
import { Icon } from './Icon.js';
export const IconDog = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3.5 19H14", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M14 10H14.01", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12.2441 6H23V11C23 14.3137 20.3137 17 17 17H15V23H13V15H17C19.2091 15 21 13.2091 21 11V8H10.7559L9.25586 3H8.76367L3.30957 23H1.23633L7.03516 1.7373L7.23633 1H10.7441L12.2441 6Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconDog.js.map